import { Vue, Component } from "vue-property-decorator";
import { AXIOS } from "@/lib/http-common";

@Component({})
export default class Info extends Vue {
    public appVersion: string = '';

    public mounted() {
        this.getVersion();
    }

    public getVersion() {
        AXIOS.get('/properties/app-version').then((appVersion) => {
            this.appVersion = appVersion.data;
        });
    }
}
